import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimulacaoVendaComponent } from './simulacao-venda/simulacao-venda.component';
import { PagamentoInteligenteRoutingModule } from './pagamento-inteligente-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { ComponentstModule } from '../../shared/components/components.module';
import { PagamentoInteligenteComponent } from './pagamento-inteligente.component';
import { ListaSimulacaoComponent } from './lista-simulacao/lista-simulacao.component';
import { MyDatePickerModule } from 'mydatepicker';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ModalSimulacaoVendaComponent } from './simulacao-venda/modal-simulacao-venda/modal-simulacao-venda.component';
import { SimulacaoVendaWebtefComponent } from './simulacao-venda-webtef/simulacao-venda-webtef.component';
import { ModalSimulacaoVendaWebtefComponent } from './simulacao-venda-webtef/modal-simulacao-venda/modal-simulacao-venda-webtef.component';
import { HistoricoVendasComponent } from './historico-vendas/historico-vendas.component';
import { ModalNotaFiscalComponent } from './historico-vendas/modal-nota-fiscal/modal-nota-fiscal.component';


@NgModule({
  declarations: [
    PagamentoInteligenteComponent,
    SimulacaoVendaComponent,
    SimulacaoVendaWebtefComponent,
    ModalSimulacaoVendaComponent,
    ListaSimulacaoComponent,
    ModalSimulacaoVendaWebtefComponent,
    HistoricoVendasComponent,
    ModalNotaFiscalComponent,
  ],
  entryComponents:[
    ModalSimulacaoVendaComponent,
    ModalSimulacaoVendaWebtefComponent,
    ModalNotaFiscalComponent,
  ],
  imports: [
    CommonModule,
    PagamentoInteligenteRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    ComponentstModule,
    NbCheckboxModule,
    MyDatePickerModule,
    CurrencyMaskModule,
  ]
})
export class PagamentoInteligenteModule { }
